// extracted by mini-css-extract-plugin
export var root = "PostsList-root-JcHNI";
export var rootDate = "PostsList-root_date-w3tyw";
export var rootItem = "PostsList-root_item-gq7gZ";
export var rootLink = "PostsList-root_link-pkauB";